<!-- eslint-disable -->
<template>
  <div>
    <div class="card-content">
      <LoadingContainer :is-loading="isLoadingModel || isLoadingItems">
        <div class="columns is-multiline">
          <div class="column is-full">
            <brand-info :brand="model" />
          </div>
        </div>

        <div class="columns">
          <div class="column is-three-quarters">
            <form class="has-sticky-submit" novalidate @submit.prevent="submit">
              <div class="card">
                <div class="card-header">
                  <div class="card-header-title">
                    <div class="title is-6 is-marginless">
                      Επεξεργασία Μάρκας
                      <span class="tag">
                        <strong>{{ model.title }}</strong>
                      </span>
                    </div>
                  </div>
                  <div class="card-header-icon">
                    <div class="field has-addons is-marginless">
                      <div class="control">
                        <router-link
                          :to="{ name: 'products.brands.list' }"
                          class="button"
                        >
                          <span class="icon is-small">
                            <i class="fa fa-list-ul" />
                          </span>
                          <span>Λίστα</span>
                        </router-link>
                      </div>
                      <div class="control">
                        <router-link
                          :to="{
                            name: 'products.brands.collections.add',
                            params: { uuid: $route.params.uuid },
                          }"
                          class="button"
                        >
                          <span class="icon is-small"
                            ><i class="fa fa-plus"/></span
                          ><span>Προσθήκη Σειράς</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-content">
                  <BrandsEditMenu />
                  <EditGeneralDetails
                    :general="general"
                    :orders="orders"
                    :can-activate="canActivate"
                    @updateGeneral="updateGeneral"
                  />
                </div>
              </div>

              <ToggleableCard :is-open="true" title="Brand Banner (WEBP)">
                <div class="card-content">
                  <AddPhotos
                    :title="'Εικόνα (WEBP)'"
                    :preview="bannerPreview"
                    :show-error="errors.has('banner_image')"
                    rule="image/webp"
                    @addPhotos="handleAddBanner"
                  />
                  <p class="help">Το αρχείο πρέπει να είναι WEBP.</p>

                  <div v-if="bannerPreview" class="mt-2">
                    <button
                      type="button"
                      class="button is-small"
                      @click="removeBanner"
                    >
                      <span class="icon is-small">
                        <i class="fa fa-trash" />
                      </span>
                      <span>Αφαίρεση</span>
                    </button>
                  </div>
                </div>
              </ToggleableCard>

              <edit-photos
                :model="model"
                :photos="photos"
                :is-loading="isLoadingPhotos"
                @updatePhotos="updatePhotos"
              />

              <ToggleableCard :is-open="true" title="Ανακατεύθυνση (301)">
                <div class="card-content">
                  <EditRedirectionDetails
                    :redirection="redirection"
                    @updateRedirection="updateRedirection"
                  />
                </div>
              </ToggleableCard>

              <ToggleableCard title="Meta">
                <div class="card-content">
                  <EditMetaDetails :meta="meta" @updateMeta="updateMeta" />
                </div>
              </ToggleableCard>

              <ToggleableCard title="Social Meta">
                <div class="card-content">
                  <EditSocialMetaDetails
                    :social-meta="socialMeta"
                    :is-read-only="true"
                    @updateSocialMeta="updateSocialMeta"
                  />
                </div>
              </ToggleableCard>

              <StickyFormFooter>
                <template v-slot:left>
                  <FormSubmit :is-saving="isSaving" @reset="reset" />
                </template>
                <template v-slot:right>
                  <a
                    v-tooltip="'Προβολή στο e-shop'"
                    :href="model.path"
                    target="_blank"
                  >
                    {{ model.title }} <i class="fa fa-arrow-right" />
                  </a>
                </template>
              </StickyFormFooter>
            </form>
          </div>
          <div class="column">
            <ExistingCategories :categories="brandCategories" :brand="model" />
            <ExistingCollections :items="collections" :brand="model" />

            <ExistingBrands :items="items" />

            <div class="card">
              <div class="card-header">
                <div class="card-header-title">
                  Dynamic Variables
                </div>
              </div>
              <div class="card-content">
                <strong>Available Variables</strong>
                <br />
                <ul>
                  <li>[brand_name]</li>
                  <li>[discount_percentage]</li>
                  <li>[count_of_products]</li>
                </ul>

                <br />

                <strong>H1 (tag) (sample)</strong>
                <br />
                <p>
                  [brand_name]
                </p>

                <br />

                <strong>Περιεχόμενο (p tag) (sample)</strong>
                <br />
                <p>
                  Ανακάλυψε τα προϊόντα [brand_name] και απόκτησε αυτά που
                  καλύπτουν ιδανικά τις ανάγκες σου, σε μοναδικές προσφορές έως
                  -[discount_percentage]%. Άμεση παράδοση, μοναδική εξυπηρέτηση
                  & τεράστια ποικιλία στις καλύτερες τιμές μόνο στο Carespot, το
                  online φαρμακείο που σε φροντίζει!
                </p>

                <br />

                <strong>Meta Title (sample)</strong>
                <br />
                <p>
                  [brand_name] Σε Προσφορές Έως -[discount_percentage]%
                </p>

                <br />

                <strong>Meta Description (sample)</strong>
                <br />
                <p>
                  Βρες προϊόντα [brand_name] σε προσφορές έως
                  -[discount_percentage]%! Άμεση παράδοση & μοναδική εξυπηρέτηση
                  μόνο στο Carespot, το online φαρμακείο που σε φροντίζει.
                </p>
              </div>
            </div>
          </div>
        </div>
      </LoadingContainer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { clone, get, isEmpty, pick } from 'lodash';
import slug from 'slug';
import request from '@/utils/request';
import AddItem from '@/views/components/AddItem';
import EditGeneralDetails from '@/views/components/EditGeneralDetails';
import EditRedirectionDetails from '@/views/components/EditRedirectionDetails';
import EditMetaDetails from '@/views/components/EditMetaDetails';
import EditSocialMetaDetails from '@/views/components/EditSocialMetaDetails';
import EditPhotos from '@/views/components/EditPhotos';
import ToggleableCard from '@/views/components/ToggleableCard';
import LoadingContainer from '@/views/components/LoadingContainer';
import StickyFormFooter from '@/views/components/StickyFormFooter';
import AddPhotos from '@/views/components/AddPhotos';
import BrandInfo from './components/BrandInfo';
import ExistingBrands from '../../components/ExistingBrands';
import ExistingCollections from '../../components/ExistingCollections';
import ExistingCategories from '../../components/ExistingCategories';
import BrandsEditMenu from '../../components/BrandsEditMenu';

export default {
  components: {
    BrandInfo,
    EditRedirectionDetails,
    EditMetaDetails,
    EditSocialMetaDetails,
    EditGeneralDetails,
    EditPhotos,
    ToggleableCard,
    LoadingContainer,
    StickyFormFooter,
    ExistingBrands,
    ExistingCollections,
    ExistingCategories,
    BrandsEditMenu,
    AddPhotos,
  },

  extends: AddItem,

  data() {
    return {
      redirection: {},
      meta: {},
      socialMeta: {},
      general: {},
      oldOrder: 0,
      photos: [],
      isLoadingPhotos: false,
      bannerImage: null,
      bannerPreview: '',
      bannerRemoved: false,
      bannerReadToken: 0,
    };
  },

  computed: {
    ...mapGetters({
      model: 'brands/edit/getBrand',
      orders: 'brands/edit/getOrders',
      items: 'brands/all/getBrands',
      collections: 'collections/all/getCollections',
      brandCategories: 'brands/all/getBrandCategoriesTree',
      isLoadingModel: 'brands/edit/getIsLoading',
      isLoadingItems: 'brands/all/getIsLoading',
    }),

    canActivate() {
      /* eslint-disable camelcase */
      return get(this.model, 'photos', []).some(
        ({ is_avatar }) => is_avatar === true,
      );
    },

    hasChangedTitle() {
      return this.model.title !== this.general.title;
    },

    hasModelSlug() {
      return this.model.slug;
    },
  },

  watch: {
    $route: 'fetchData',

    model: {
      handler(newVal) {
        this.general = pick(newVal, [
          'title',
          'slug',
          'description',
          'content',
          'active',
          'order',
        ]);

        this.oldOrder = this.general.order;

        this.redirection = clone(
          newVal.redirection || {
            new: null,
            old: null,
          },
        );
        this.meta = clone(newVal.meta);
        this.socialMeta = clone(newVal.social_meta);

        this.photos = clone(this.model.photos);

        if (!this.bannerImage && !this.bannerRemoved) {
          this.bannerPreview = this.getBannerUrl(newVal);
        }

        this.errors.remove('banner_image');
      },
      deep: true,
    },

    'general.title': {
      handler(newVal, oldVal) {
        if (!isEmpty(this.model) && newVal !== oldVal) {
          if (
            (!this.hasChangedTitle && !this.hasModelSlug) ||
            this.hasChangedTitle
          ) {
            const newSlug = slug(newVal.toLowerCase());
            this.general.slug = newSlug;

            const newRedirection = {
              ...this.model.redirection,
              new: `https://carespot.gr/${newSlug}`,
            };

            this.updateRedirection(newRedirection);

            const titleRegExp = new RegExp(this.model.title, 'g');
            const slugRegExp = new RegExp(this.model.slug, 'g');

            const newMeta = {
              ...this.model.meta,
              title: this.model.meta.title.replace(titleRegExp, newVal),
              description: this.model.meta.description.replace(
                titleRegExp,
                newVal,
              ),
              keywords: this.model.meta.keywords.replace(titleRegExp, newVal),
              schema: this.model.meta.schema.replace(slugRegExp, newSlug),
            };

            this.updateMeta(newMeta);

            const newSocialMeta = {
              ...this.model.social_meta,
              og_title: this.model.social_meta.og_title.replace(
                titleRegExp,
                newVal,
              ),
              og_description: this.model.social_meta.og_description.replace(
                titleRegExp,
                newVal,
              ),
              og_url: this.redirection.new,
              twitter_title: this.model.social_meta.twitter_title.replace(
                titleRegExp,
                newVal,
              ),
              twitter_description: this.model.social_meta.twitter_description.replace(
                titleRegExp,
                newVal,
              ),
            };

            this.updateSocialMeta(newSocialMeta);
          }

          if (!this.hasChangedTitle && this.hasModelSlug) {
            const values = pick(this.model, [
              'title',
              'slug',
              'description',
              'content',
              'active',
              'order',
            ]);

            this.general = {
              ...this.general,
              ...values,
            };

            this.oldOrder = this.general.order;

            this.redirection = clone(
              this.model.redirection || {
                new: null,
                old: null,
              },
            );
            this.meta = clone(this.model.meta);
            this.socialMeta = clone(this.model.social_meta);

            this.photos = clone(this.model.photos);

            if (!this.bannerImage && !this.bannerRemoved) {
              this.bannerPreview = this.getBannerUrl(this.model);
            }

            this.errors.remove('banner_image');
          }
        }
      },
    },
  },

  async created() {
    await this.fetchData();
  },

  methods: {
    ...mapActions({
      getBrand: 'brands/edit/getBrand',
      updateBrand: 'brands/edit/updateBrand',
      getBrandPhotos: 'brands/edit/getBrandPhotos',
      getBrands: 'brands/all/getBrands',
      getCollections: 'collections/all/getCollections',
      getBrandCategories: 'brands/all/getBrandCategories',
    }),

    /**
     * Single source of truth for banner URL selection.
     * Prefer banner_image_full_url; fallback to banner_image_url; else ''.
     */
    getBannerUrl(brand) {
      if (!brand) return '';
      return brand.banner_image_full_url || brand.banner_image_url || '';
    },

    async fetchData() {
      try {
        await Promise.all([
          this.getBrand({ uuid: this.$route.params.uuid }),
          this.getBrands(),
          this.getCollections({ uuid: this.$route.params.uuid }),
          this.getBrandCategories({ uuid: this.$route.params.uuid }),
        ]);
      } catch (err) {
        this.$router.push('/error').catch(e => console.log(e));
      }
    },

    handleAddBanner(image) {
      const file = Array.isArray(image) ? image[0] : image;

      this.bannerImage = file;
      this.bannerRemoved = false;

      this.bannerReadToken += 1;
      const currentToken = this.bannerReadToken;

      const reader = new FileReader();
      this.$validator
        .validateAll()
        .then(() => {
          reader.onload = e => {
            if (currentToken !== this.bannerReadToken) return;
            if (this.bannerImage !== file) return;
            if (this.bannerRemoved) return;

            this.bannerPreview = e && e.target ? e.target.result : '';
            this.errors.remove('banner_image');
          };
          reader.readAsDataURL(file);
        })
        .catch(() => {});
    },

    removeBanner() {
      this.bannerReadToken += 1;
      this.bannerImage = null;
      this.bannerPreview = '';
      this.bannerRemoved = true;
      this.errors.remove('banner_image');
    },

    async submit() {
      try {
        const validations = await Promise.all(
          this.$children.map(child => child.$validator.validateAll()),
        );
        const isValid = validations.every(Boolean);

        if (!isValid) {
          throw Error('Client-side validation failed');
        }

        this.isSaving = true;

        const order = {
          old: this.oldOrder,
          new: this.general.order,
        };

        await this.updateBrand({
          uuid: this.model.uuid,
          brand: {
            ...this.general,
            order,
            redirection: this.redirection,
            meta: this.meta,
            socialMeta: this.socialMeta,
          },
        });

        const hasBannerFile =
          this.bannerImage &&
          typeof File !== 'undefined' &&
          this.bannerImage instanceof File;

        const shouldCallBanner = hasBannerFile || this.bannerRemoved === true;

        if (shouldCallBanner) {
          const fd = new FormData();
          fd.append('banner_image_remove', this.bannerRemoved ? '1' : '0');

          if (hasBannerFile) {
            fd.append('banner_image', this.bannerImage);
          }

          const resp = await request.post(
            `/brands/${String(this.model.uuid)}/banner`,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } },
          );

          if (!resp || resp.status !== 200) {
            const m =
              (resp && resp.data && resp.data.message) || 'To αίτημα απέτυχε';
            throw new Error(m);
          }
        }

        this.isSaving = false;

        this.$notify({
          type: 'success',
          title: 'Επιτυχία',
          text: 'Η μάρκα αποθηκεύτηκε',
        });

        await this.fetchData();
      } catch (err) {
        this.isSaving = false;

        const msg =
          (err &&
            err.response &&
            err.response.data &&
            err.response.data.message) ||
          (err && err.message) ||
          'To αίτημα απέτυχε';

        this.$notify({
          type: 'error',
          title: 'Αποτυχία',
          text: msg,
        });
      }
    },

    reset() {
      this.general = pick(this.model, [
        'title',
        'slug',
        'description',
        'content',
        'active',
        'order',
      ]);

      this.oldOrder = this.general.order;

      this.meta = clone(this.model.meta);
      this.socialMeta = clone(this.model.social_meta);
      this.photos = clone(this.model.photos);

      this.bannerReadToken += 1;
      this.bannerImage = null;
      this.bannerRemoved = false;
      this.bannerPreview = this.getBannerUrl(this.model);
      this.errors.remove('banner_image');

      this.$children.forEach(child => child.$validator.reset());
    },

    updateRedirection(redirection) {
      this.redirection = redirection;
    },

    updateMeta(meta) {
      this.meta = meta;
    },

    updateSocialMeta(socialMeta) {
      this.socialMeta = socialMeta;
    },

    updateGeneral(general) {
      this.general = general;
    },

    async updatePhotos() {
      try {
        this.isLoadingPhotos = true;
        await this.getBrandPhotos({ uuid: this.$route.params.uuid });
        this.isLoadingPhotos = false;
      } catch (err) {
        this.isLoadingPhotos = false;
      }
    },
  },
};
</script>
